<template lang="pug">
  b-container(fluid)
    h2
      .d-flex.align-items-center
        span {{name}}
        b-spinner(small, variant="primary", v-if="loading")
    .get-started
      p.mb-0 Botón Inicio
      p.text-secondary Este botón permite iniciar una conversación enviando al usuario a tu bloque principal.
      .text-center(v-if="loading")
        b-spinner(variant="primary")
      block-connector(v-else, :flow_id="get_started.flow_id", :next_block_id="get_started.next_block", @change="updateGetStarted")
      .text-center
        b-link.text-sm.text-danger(@click="updateGetStarted()", v-if="has_get_started") Quitar botón
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      loading: false,
      get_started: {
        type: 'next_block',
        next_block: null,
        flow_id: null
      },
    }
  },
  props: {
    name: {
      default: ''
    },
    model_id: {
      default: null
    }
  },
  computed: {
    has_get_started () {
      return !!this.get_started.next_block
    },
  },
  methods: {
    ...mapActions(['alexa/get', 'alexa/update']),
    getAlexa () {
      let self = this
      this.loading = true
      this['alexa/get']({
        account_id: self.$route.params.account_id,
        alexa_id: self.model_id,
        callback: res => {
          if (res.error) {
            self.$message.warning(res.error)
          } else {
            this.get_started.next_block = res.resource.get_started
          }
          self.loading = false
        }
      })
    },
    updateGetStarted (data) {
      if(data){
        this.get_started.next_block = data.next_block_id
        this.get_started.flow_id = data.flow_id
      } else {
        this.get_started.next_block = null
        this.get_started.flow_id = null
      }
      this.updateVoicebot()
    },
    updateVoicebot () {
      let self = this
      this.loading = true
      this['alexa/update']({
        account_id: self.$route.params.account_id,
        alexa_id: self.model_id,
        get_started: this.get_started.next_block,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.warning(res.error)
          } else {
            self.$message.success('Alexa actualizada')
          }
        }
      })
    }
  },
  mounted () {
    this.getAlexa()
  }
}
</script>

<style lang="scss" scoped>
  .menu-item {
    position: relative;
    box-sizing: border-box;
    &:hover {
      .menu-delete {
        display: inline-block;
      }
    }
  }

  .menu-actions {
    position: absolute;
    right: 5px;
  }

  .menu-delete {
    display: none;
  }

  .whitelist-container {
    max-height: 400px;
  }
</style>
